export default __webpack_public_path__ + "static/assets/a3e64cfaded3f2854d83135d026e664d.jpg";